import React, { useEffect, useRef, useState } from 'react';
import './Hero.css';
import { CONFIG } from '../data';

const FLOATERS = [
  { emoji: '🍛', size: 52, top: '12%', left: '6%',  duration: '7s',  delay: '0s'   },
  { emoji: '🌶️', size: 36, top: '70%', left: '4%',  duration: '9s',  delay: '1s'   },
  { emoji: '🍃', size: 44, top: '30%', left: '88%', duration: '8s',  delay: '0.5s' },
  { emoji: '🫙', size: 38, top: '75%', left: '85%', duration: '10s', delay: '2s'   },
  { emoji: '🌿', size: 48, top: '55%', left: '92%', duration: '6s',  delay: '1.5s' },
  { emoji: '🍲', size: 56, top: '18%', left: '82%', duration: '11s', delay: '0.8s' },
  { emoji: '🧄', size: 32, top: '82%', left: '14%', duration: '8s',  delay: '3s'   },
  { emoji: '🫚', size: 34, top: '48%', left: '3%',  duration: '9s',  delay: '2.5s' },
  { emoji: '🍚', size: 42, top: '8%',  left: '72%', duration: '7s',  delay: '1.2s' },
  { emoji: '🌰', size: 30, top: '90%', left: '55%', duration: '12s', delay: '0s'   },
  { emoji: '🫛', size: 38, top: '22%', left: '14%', duration: '10s', delay: '3.5s' },
  { emoji: '🍯', size: 40, top: '60%', left: '78%', duration: '8s',  delay: '1.8s' },
];

function useCounter(target, duration = 2000, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function Hero() {
  const goMenu = () => document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
  const waUrl = `https://wa.me/${CONFIG.whatsappNumber}?text=${encodeURIComponent(CONFIG.whatsappMessage)}`;
  const statsRef = useRef(null);
  const [statsVisible, setStatsVisible] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setPageLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setStatsVisible(true); },
      { threshold: 0.5 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  const events = useCounter(1000, 2000, statsVisible);
  const dishes = useCounter(30,  1800, statsVisible);
  const years  = useCounter(25,  1600, statsVisible);

  return (
    <section id="hero" className={`hero ${pageLoaded ? 'loaded' : ''}`}>
      <div className="hero-bg">
        <div className="hero-bg-inner"/>
        <div className="hero-slant"/>
      </div>
      <div className="hero-ring"/>
      <div className="hero-floaters">
        {FLOATERS.map((f, i) => (
          <span key={i} className="floater" style={{
            fontSize: f.size, top: f.top, left: f.left,
            animationDuration: f.duration, animationDelay: f.delay,
          }}>{f.emoji}</span>
        ))}
      </div>
      <div className="hero-content">
        <div className="hero-badge">
          <span className="hero-dot"/>
          <span>Authentic Since Generations</span>
          <span className="hero-dot"/>
        </div>
        <h1 className="hero-title">
          <span>The Soul of</span>
          <span className="hero-title-gold">Chettinad</span>
          <span>on Every Plate</span>
        </h1>
        <p className="hero-desc">
          Stone-ground spices. Banana leaf feasts. Recipes passed down through
          generations from the heart of Karaikudi — now at your celebration.
        </p>
        <div className="hero-btns">
          <a href={waUrl} target="_blank" rel="noopener noreferrer" className="btn-main">
            📲 Book via WhatsApp
          </a>
          <button className="btn-ghost" onClick={goMenu}>Explore Menu</button>
        </div>
        <div className="hero-stats" ref={statsRef}>
          <div className="hstat">
            <strong>{events}+</strong>
            <span>Events Catered</span>
          </div>
          <div className="hstat-div"/>
          <div className="hstat">
            <strong>{dishes}+</strong>
            <span>Signature Dishes</span>
          </div>
          <div className="hstat-div"/>
          <div className="hstat">
            <strong>{years}+</strong>
            <span>Years Experience</span>
          </div>
        </div>
      </div>
      <div className="hero-scroll">
        <span>Scroll</span>
        <div className="scroll-line"/>
      </div>
    </section>
  );
}

export default Hero;